import { useNavigate } from 'react-router-dom';
import { Map as MapIcon, ArrowRight } from 'lucide-react';
import { formatNextRun, prettyMap } from '../../../utils/overview-format';
import { InfoGridCard, CardLink } from '../InfoGridCard';
import type { SteamOverview } from './types';

const RCON_LABEL = {
  ready: { text: 'RCON verbunden', cls: 'text-online' },
  waiting: { text: 'wartet auf den Server', cls: 'text-warn' },
  none: { text: 'Standard-Konsole', cls: 'text-fg-muted' },
};

/** „Welt & Server": die spielrelevanten Eckdaten der Steam-Übersicht. */
export const WorldInfoCard = ({ overview, online, serverId }: { overview: SteamOverview; online: boolean; serverId: string }) => {
  const navigate = useNavigate();
  const rcon = RCON_LABEL[overview.rcon];
  const version = overview.query?.version;
  const max = overview.maxPlayers || overview.query?.maxPlayers;

  return (
    <InfoGridCard
      icon={<MapIcon size={15} className="text-fg-muted" />}
      title="Welt & Server"
      action={<CardLink onClick={() => navigate(`/server/${serverId}/settings`, { state: { section: 'spiel' } })}>Bearbeiten <ArrowRight size={13} /></CardLink>}
      cells={[
        { label: 'Karte', value: prettyMap(overview.map || overview.query?.map) || '—' },
        { label: 'Version', value: version ? <span className="font-mono">v{version}</span> : <span className="text-fg-muted">—</span> },
        {
          label: 'Mods',
          value: overview.mods.count
            ? `${overview.mods.count} aktiv`
            : <>Keine{overview.mods.type === 'workshop' && <span className="text-fg-muted"> · Workshop bereit</span>}</>,
        },
        { label: 'Max. Spieler', value: <span className="font-mono">{max ?? '—'}</span> },
        {
          label: 'Nächstes Backup',
          value: overview.nextBackupAt
            ? <>
                {formatNextRun(overview.nextBackupAt)}
                <span className="text-fg-muted">{online ? (overview.backupScoped ? ' · nur Spielstand' : '') : ' · nur wenn der Server läuft'}</span>
              </>
            : <span className="text-fg-muted">nicht geplant</span>,
        },
        { label: 'Konsole', value: <span className={rcon.cls}>{rcon.text}</span> },
      ]}
    />
  );
};
